<template>
  <div id="Reimbursement">
    <div class="title">费用报销表</div>
    <div class="content">
      <div class="header_info">
        <div>
          <div>日期</div>
          <el-date-picker
            v-if="!showEdit"
            v-model="datas[0].date"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            style="width: 140px"
            placeholder="选择日期"
          >
          </el-date-picker>
          <div v-else>{{ $formart(datas[0].date, "yyyy-MM-dd") }}</div>
        </div>
        <div>
          <div>附单据</div>
          <el-input
            v-if="!showEdit"
            size="mini"
            style="width: 60px"
            v-model="datas[0].billNum"
          ></el-input>
          <div v-else>{{ datas[0].billNum }}</div>
          <div>张</div>
        </div>
      </div>

      <div class="content_info">
        <div class="content_1">
          <div class="left">
            <div class="field">
              <div style="width: 250px; border-right: 1px solid #666666">
                费用项目
              </div>
              <div style="flex: 1; border-right: 1px solid #666666">类别</div>
              <div style="flex: 1">金额</div>
            </div>
            <div class="items">
              <div
                v-for="(item, index) in datas[0].item"
                :key="index"
                class="itemClass"
              >
                <div style="width: 250px; border-right: 1px solid #666666">
                  <el-input
                    v-model="item.expenseItem"
                    v-if="!showEdit"
                    size="mini"
                    maxlength="15"
                  ></el-input>
                  <span v-else>{{ item.expenseItem }}</span>
                </div>
                <div style="flex: 1; border-right: 1px solid #666666">
                  <el-input
                    v-model="item.category"
                    v-if="!showEdit"
                    maxlength="15"
                    size="mini"
                  ></el-input>
                  <span v-else>{{ item.category }}</span>
                </div>
                <div style="flex: 1">
                  <el-input
                    v-model="item.money"
                    v-if="!showEdit"
                    maxlength="15"
                    size="mini"
                    @blur="moneyChange"
                     oninput="value=value.replace(/[^0-9.]/g,'').replace(/(\..*)\./g, '\$1')"
                  ></el-input>
                  <span v-else>{{ item.money }}</span>
                </div>
              </div>
            </div>
            <div class="items_total">
              <div style="width: 250px; border-right: 1px solid #666666">
                报销金额合计
              </div>
              <div style="width: 148px; border-right: 1px solid #666666"></div>
              <div style="flex: 1"></div>
            </div>
          </div>
          <div class="right">
            <div class="box">
              <div>负责人</div>
              <div>
                <el-input
                  v-model="datas[0].personCharge"
                  v-if="!showEdit"
                  type="textarea"
                ></el-input>
                <div v-else class="right_name">{{ datas[0].personCharge }}</div>
              </div>
            </div>
            <div class="box">
              <div>审核意见</div>
              <div>
                <el-input
                  v-model="datas[0].reviewOpinions"
                  v-if="!showEdit"
                  type="textarea"
                ></el-input>
                <div v-else class="right_name">
                  {{ datas[0].reviewOpinions }}
                </div>
              </div>
            </div>
            <div class="box">
              <div>报销人</div>
              <div>
                <el-input
                  v-model="datas[0].reimburser"
                  v-if="!showEdit"
                  type="textarea"
                  maxlength="15"
                ></el-input>
                <div v-else class="right_name">{{ datas[0].reimburser }}</div>
              </div>
            </div>
            <div class="lastbox">
              ¥
              {{ datas[0].totalMoney }}
              <!-- <el-input
                v-if="!showEdit"
                maxlength="15"
                v-model="datas[0].totalMoney"
                size="mini"
                di
              ></el-input> -->
            </div>
          </div>
        </div>
        <div class="content_2">
          <div style="display:flex;">核实金额（大写）
            <div>{{datas[0].numMoneyT}}</div>
          </div>
          <div style="margin-left: 5px" class="verifyAmount">
            ¥
            <el-input
              v-if="!showEdit"
              maxlength="15"
              v-model="datas[0].verifyAmount"
              @blur="moneyChange"
              oninput="value=value.replace(/[^0-9.]/g,'').replace(/(\..*)\./g, '\$1')"
              size="mini"
            ></el-input>
            <div v-else>{{datas[0].verifyAmount}}</div>
          </div>
        </div>
        <div class="content_3">
          <div>
            <div style="width: 80px">借款金额</div>
            <el-input
              size="mini"
              v-model="datas[0].loan"
              maxlength="15"
              @blur="moneyChange"
            ></el-input>
          </div>
          <div>
            <div style="width: 80px">应退金额</div>
            <el-input
              size="mini"
              v-model="datas[0].refund"
              @blur="moneyChange"
              maxlength="15"
            ></el-input>
          </div>
          <div>
            <div style="width: 80px">应补金额</div>
            <el-input
              size="mini"
              maxlength="15"
              @blur="moneyChange"
              v-model="datas[0].amountSupplemented"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div>
          <div style="width: 38px">审核</div>
          <el-input
            size="mini"
            v-model="datas[0].reviewer"
            v-if="!showEdit"
            maxlength="15"
          ></el-input>
          <div v-else>{{ datas[0].reviewer }}</div>
        </div>
        <div>
          <div style="width: 38px">出纳</div>
          <el-input
            size="mini"
            v-model="datas[0].cashier"
            v-if="!showEdit"
            maxlength="15"
          ></el-input>
          <div v-else>{{ datas[0].cashier }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { chineseNumbers } from "@/assets/utils/dom";
import html2canvas from "html2canvas";
import { uploadUrlTwo } from "@/assets/js/apiConfig.js";
import { toFixed } from 'xe-utils/methods';
export default {
  props: {
    currentPage: {
      type: Number | String,
      default: 1,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    tableData(val) {
      console.log(val);
      this.datas = val.map((e) => {
        let total = 0;
        e.verifyAmount = e.verifyAmount||''
        e.loan = e.loan || ''
        e.refund = e.refund || ''
        e.amountSupplemented = e.amountSupplemented || ''
        // if(e.verifyAmount>0){
        //   this.$set(e,'numMoneyT',chineseNumbers(e.verifyAmount))
        // }
        e.item.forEach((x) => {
          if (x.money == 0) {
            x.money = "";
          }else 
          total += Number(x.money);
        });
        this.$set(e, "totalMoney", total > 0 ? Number(total).toFixed(2) : "");
        return e;
      });
    },
  },
  methods: {
    moneyChange() {
      this.datas = this.datas.map((e) => {
        let total = 0;
        e.verifyAmount = e.verifyAmount?Number(e.verifyAmount).toFixed(2):''
        e.loan = e.loan || ''
        e.refund = e.refund || ''
        e.amountSupplemented = e.amountSupplemented || ''
        if(e.verifyAmount>0){
          this.$set(e,'numMoneyT',chineseNumbers(e.verifyAmount))
        }else {
           this.$set(e,'numMoneyT','')
        }
        e.item.forEach((x) => {
          x.money = Number(x.money).toFixed(2) || ''
          if (x.money == 0) {
            x.money = "";
          }
          total += Number(x.money);
        });
        this.$set(e, "totalMoney", total > 0 ? Number(total).toFixed(2) : "");
        return e;
      });
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const bstr = atob(arr[1]);

      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: "image/png" });
    },
    changeEdit(key) {
      console.log(key, "opopoppop");
      this.showEdit = key;
    },
    async generateImage(key) {
      await this.changeEdit(key);
      const element = document.getElementById("Reimbursement");
      const canvas = await html2canvas(element, {
        useCORS: true, // 允许跨域图片
        logging: false, // 关闭警告
        width: 842,
        height: 562,
        // scale: 2,
        ignoreElements: (element) => false, // 强制渲染所有元素
      });
      console.log(canvas);
      const imgUrl = canvas.toDataURL("image/png");
      // 转 File 对象
      const file = this.dataURLtoFile(
        imgUrl,
        `费用报销表_${this.currentPage}.png`
      );
      const formatDate = new FormData();
      formatDate.append("file", file);
      const { data } = await this.$http.post(uploadUrlTwo, formatDate, {
        upload: true,
      });
      return Promise.resolve(data.data[0]);
    },
  },
  data() {
    return {
      datas: [
        {
          amountSupplemented: "",
          billNum: "",
          cashier: "",
          date: "",
          loan: "",
          personCharge: "",
          refund: "",
          reviewer: "",
          reviewOpinions: "",
          reimburser: "",
          totalMoney: "",
          verifyAmount:"",
          item: [
            {
              category: "",
              expenseItem: "",
              money: "",
            },
            {
              category: "",
              expenseItem: "",
              money: "",
            },
            {
              category: "",
              expenseItem: "",
              money: "",
            },
            {
              category: "",
              expenseItem: "",
              money: "",
            },
          ],
        },
      ],
      showEdit: false,
    };
  },
};
</script>
<style lang="less" scoped>
.verifyAmount {
  display: flex;
  align-items: center;
  /deep/ .el-input__inner {
    border: 0 !important;
  }
}
/deep/ .el-textarea__inner {
  resize: none !important;
  border: 0 !important;
  height: 78px !important;
}
.right_name {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#Reimbursement {
  background: #fff;
  color: #333333 !important;
  height: 596px;
  //   width: 882;
  padding: 64px 30px;
  //   margin-left: -20px;
  box-sizing: border-box;
  .title {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 24px;
    color: #333333;
    text-align: center;
  }
  .header_info {
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: flex-end;
    margin-top: 20px;
    & > div {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
  .content_1 {
    width: 100%;
    margin-top: 5px;
    height: 280px;
    border: 1px solid #666666;
    box-sizing: border-box;
    display: flex;
    .left {
      width: 545px;
      border-right: 1px solid #666666;
      .items_total {
        height: calc(100% - 241px);
        display: flex;
        & > div {
          padding: 10px;
          box-sizing: border-box;
        }
      }
      .field {
        display: flex;
        border-bottom: 1px solid #666666;
        text-align: center;

        & > div {
          padding: 10px;
          height: 40px;
          box-sizing: border-box;
        }
      }
      .itemClass {
        height: 40px;
        box-sizing: border-box;
        border-bottom: 1px solid #666666;
        display: flex;
        /deep/ .el-input__inner {
          border: 0 !important;
        }
        & > div {
          padding: 5px 10px;
          height: 40px;
          box-sizing: border-box;
        }
      }
    }
    .right {
      flex: 1;
      .lastbox {
        display: flex;
        align-items: center;
        padding: 10px;
        box-sizing: border-box;
        height: 40px;
        /deep/ .el-input__inner {
          border: 0 !important;
        }
      }
      .box {
        display: flex;
        & > div:first-child {
          line-height: 80px;
          text-align: center;
          border-right: 1px solid #666666;
        }
        & > div {
          width: 50%;
          // flex:1
        }
      }
      & > div {
        height: 80px;
        border-top: 1px solid #666666;
        box-sizing: border-box;
        // padding: 10px;
        &:first-child {
          border-top: 0;
        }
      }
    }
  }
  .content_2 {
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    & > div {
      &:first-child {
        width: 540px;
      }
      &:last-child {
        flex: 1;
      }
    }
  }
  .content_3 {
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    gap: 10px;
    // justify-content: space-betweent;
    & > div {
      display: flex;
      align-items: center;
      width: 33%;
      gap: 5px;
      input {
        flex: 1;
      }
      /deep/ .el-input__inner {
        border: 0 !important;
      }
    }
  }
  .content_2,
  .content_3 {
    border: 1px solid #666666;
    border-top: 0;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
  }
  .bottom {
    margin-top: 10px;
    width: 100%;
    gap: 70px;
    display: flex;
    & > div {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/table/Reimbursement.vue